// ─────────────────────────────────────────────────────────────────
// Glass-i — Dispatch Plan helpers (Feature 2 + 3). Permission keys, readiness
// status presentation, and date/qty formatting. Pure — no side effects.
// ─────────────────────────────────────────────────────────────────

export const PERM = Object.freeze({
  VIEW: 'erp.dispatch.plan.view',
  CREATE: 'erp.dispatch.plan.create',
  UPDATE: 'erp.dispatch.plan.update',
  DELETE: 'erp.dispatch.plan.delete'
});

export function hasPerm(me, key) {
  const list = (me && me.permissions) || [];
  return list.includes('*') || list.includes(key);
}

// Readiness status → { label, color } for an AntD Tag.
const READINESS = {
  READY: { label: 'Ready', color: 'green' },
  PARTIAL: { label: 'Partially ready', color: 'gold' },
  PENDING: { label: 'In production', color: 'blue' },
  NO_PIECES: { label: 'No pieces', color: 'default' }
};
export function readinessTag(status) { return READINESS[status] || READINESS.NO_PIECES; }

const PLAN_STATUS = {
  DRAFT: { label: 'Draft', color: 'blue' },
  CONFIRMED: { label: 'Confirmed', color: 'green' },
  CANCELLED: { label: 'Cancelled', color: 'default' }
};
export function planStatusTag(status) { return PLAN_STATUS[status] || { label: status || '—', color: 'default' }; }

// Vehicle arrangement (Stage DISPATCH-PLAN-3). mode null = Pending (not yet called).
export const VEHICLE_MODE = Object.freeze({ CUSTOMER: 'CUSTOMER', COMPANY: 'COMPANY' });
const VEHICLE = {
  CUSTOMER: { label: 'Customer vehicle', color: 'blue' },
  COMPANY: { label: 'Company arranged', color: 'geekblue' }
};
export function vehicleModeTag(mode) {
  return VEHICLE[mode] || { label: 'Pending', color: 'gold' };
}

export function fmtDate(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  return `${day}-${d.toLocaleString('en-US', { month: 'short' })}-${d.getFullYear()}`;
}
export function fmtWindow(from, to) {
  if (from && to && from === to) return fmtDate(from);
  return `${fmtDate(from)} → ${fmtDate(to)}`;
}

// Whole-number count with Indian grouping (piece counts stay whole — CLAUDE.md 5A
// governs AREA precision, not counts).
export function fmtQty(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '0';
  return new Intl.NumberFormat('en-IN').format(Math.round(v));
}

// Glass AREA in m² at EXACTLY 3 decimals with Indian grouping (CLAUDE.md 5A).
export function fmtArea(sqm) {
  const v = Number(sqm);
  return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
    .format(Number.isFinite(v) ? v : 0);
}

// Per-piece area (m²) from width/height in mm.
export function pieceAreaSqm(widthMm, heightMm) {
  const w = Number(widthMm); const h = Number(heightMm);
  if (!Number.isFinite(w) || !Number.isFinite(h)) return 0;
  return (w * h) / 1e6;
}
